import React, { memo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import { RootState } from '../../../store/rootReducer'
import { MemberState } from '../../../store/member/memberTypings'

import GuestbookPopup from '../popups/guestbookPopup'
import CheckboxInput from '../../ui/checkboxInput'
import GuestbookItem from './guestbookItem'
import Button from '../../ui/button'

import { GuestbookMessage, Profile } from '../../../store/commonTypes'

import { guestbookSwitch } from '../../../store/member/memberSlice'
import isEmpty from 'lodash/isEmpty'
import { isUserPro } from '../../../utils/isUserPro'
import { openPremiumDialog } from '../../../store/common/commonSlice'
import paths from '../../../paths'
import s from './materialPreview.module.sass'
import ButtonLink from '../../ui/buttonLink'
import LoginDialog from '../../informationWindow/loginDialog'

interface Props {
    self?: boolean
    user: Profile
    guestbookItems: GuestbookMessage[]
    guestbookTotal: number
}

const GuestbookPreview = ({ self, user, guestbookItems, guestbookTotal }: Props) => {
    const [t] = useTranslation()
    const dispatch = useDispatch()

    const member = useSelector<RootState, MemberState>((state) => state.member)

    const [showPopup, setShowPopup] = useState(false)
    const [loginDialog, setLoginDialog] = useState(false)

    const emptyGuestbook = isEmpty(guestbookItems)

    const handleGuestbookSwitch = (): void => {
        dispatch(guestbookSwitch({ guestbook_disabled: user.guestbook_disabled ? 0 : 1 }))
    }

    return (
        <div className={s['materialsPreview']}>
            <div className={s['materialsPreview__row']}>
                <div className={s['materialsPreview__row']}>
                    <div className={s['materialsPreview__title']}>{self ? t('My guestbook') : t('Guestbook')}</div>
                    <div data-testid={'guestbookCounter'} className={s['materialsPreview__counter']}>
                        {!emptyGuestbook && guestbookTotal}
                    </div>
                </div>
                {self && (
                    <CheckboxInput
                        label={t('Disable')}
                        id="guestbook_disable"
                        onChange={handleGuestbookSwitch}
                        checked={!!user.guestbook_disabled}
                    />
                )}
                {!self && !user.guestbook_disabled && (
                    <Button
                        label={t('Add a message')}
                        small
                        onClick={() => {
                            member.loggedIn ? setShowPopup(true) : setLoginDialog(true)
                        }}
                    />
                )}
            </div>
            {emptyGuestbook ? (
                <div className={s['materialsPreview__emptyPlaceholder']}>
                    <div className={s['header']}>{`${
                        self
                            ? t('You dont have any guestbook messages')
                            : `${user.nick + t(' doesnt have any guestbook messages')} `
                    } `}</div>
                </div>
            ) : (
                <div className={s['materialsPreview__list']}>
                    {guestbookItems.map((guestbookItem: GuestbookMessage) => (
                        <GuestbookItem guestbookItem={guestbookItem} key={guestbookItem.id} />
                    ))}
                </div>
            )}
            {!emptyGuestbook && (
                <ButtonLink
                    secondary
                    linkUrl={self ? paths.myGuestbook.path : paths.profileGuestbook.toPath({ nick: user.nick })}
                    label={self ? t('All of my guestbook') : t('All guestbook messages')}
                />
            )}
            {showPopup && <GuestbookPopup user={user} onClose={() => setShowPopup(false)} />}
            <LoginDialog loginDialog={loginDialog} setLoginDialog={setLoginDialog} />
        </div>
    )
}

export default memo(GuestbookPreview)
